import { memoize } from "lodash";
import { observable } from "mobx";
import { COMMENTS_DEFAULT_NUMBER } from "../../../constants/input-entries-constants";

class userLoadMoreStore {
  userID: number;
  loadMore = observable.box<number>(COMMENTS_DEFAULT_NUMBER);
  constructor(userID: any) {
    this.userID = userID;
  }
}

export const getUserLoadMoreStore = memoize(
  (userID) => {
    return new userLoadMoreStore(userID);
  },
  (userID: number) => userID
);
export default getUserLoadMoreStore;
